
    import * as React from 'react';

    const PauseFilled72 = ({ color = 'currentcolor', height = '72px', width = '72px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 72 72" fill="none" style={svgStyle}><circle cx={36} cy={36} r={36} fillOpacity={0.7} /><path fillRule="evenodd" clipRule="evenodd" d="M25.75 23V49.25H24V23H25.75Z" fill="white" stroke="white" strokeWidth={2} /><path fillRule="evenodd" clipRule="evenodd" d="M48.5 23V49.25H46.75V23H48.5Z" fill="white" stroke="white" strokeWidth={2} /></svg>
        </div>
      );
    };

    PauseFilled72.displayName = 'PauseFilled72';

    export default PauseFilled72;
  